var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgComputeri = function SvgComputeri(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1594"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    d: "M9 15.5h6",
    "data-name": "Line 120"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    d: "M8 17h8",
    "data-name": "Line 121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M19 12.4V4.86a.9.9 0 0 0-.94-.86H5.94a.9.9 0 0 0-.94.86v7.54l-.98 6.5a.9.9 0 0 0 .8 1.1h14.36a.9.9 0 0 0 .8-1.1zM6.6 5.6h10.8v6.88H6.6zm-.9 12.8.68-4.4h11.24l.67 4.4z",
    "data-name": "Path 4662"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgComputeri);
export default ForwardRef;